import * as React from "react";

import { WithStyles } from "@material-ui/core";
import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import Text from "../Text";

import guillemets from "./quote.svg";

type ClassNames = "container" | "author" | "avatar" | "guillemets" | "innerContainer";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        padding: theme.spacing.unit * 2,
        borderColor: theme.palette.grey[300],
        borderWidth: 2,
        borderStyle: "solid",
        borderRadius: 5,
        backgroundColor: "white",
        margin: theme.spacing.unit * 4
    },
    innerContainer: {
        position: "relative"
    },
    guillemets: {
        height: 48,
        top: -48,
        position: "absolute"
    },
    author: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    avatar: {
        borderRadius: 9999,
        objectFit: "cover",
        height: 32,
        width: 32,
        marginRight: theme.spacing.unit * 2
    }
});

export interface QuoteProps {
    quote: string,
    handle: string,
    avatar: string,
    position: string
}

class Quote extends React.Component<WithStyles<ClassNames> & QuoteProps> {

    public render() {
        const {classes, quote, avatar, handle, position} = this.props;
        return (
            <div className={classes.container}>
                <div className={classes.innerContainer}>
                    <img src={guillemets} className={classes.guillemets} />
                    <Text variant="quote" align="center">{`“${quote}”`}</Text>
                    <div className={classes.author}>
                        <img src={avatar} className={classes.avatar} />
                        <Text variant="footnote" gutterBottom={false}>{`${handle}, ${position}`}</Text>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)<QuoteProps>(Quote);



// WEBPACK FOOTER //
// ./src/components/quotes/Quote.tsx